import { ReelInit, SymbolObject, SYMBOLS_PER_REEL_FEATURE } from "./ReelInit";

import { Group /*, Easing*/, Tween } from "tweedle.js";

import { getSymbol } from "../../config/getSymbol";
import {
    REEL_NUMBERS,
    SYMBOL_HEIGHT
} from "../../config/reelConfig";

import { sound } from "@pixi/sound";
import { WinSeqComponent } from "../../components/TransCoins/WinSeqComponent";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { spinData } from "../../server/getServerResposesFun";
import { DisplayComponent } from "../displays/DisplayComponent";
import { Manager } from "../Manager";
import { BLANK_SYM_ID } from "./ReelInit";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";

const reelTweenGroup = new Group();

// const POS_MOVE_TIME = 150;



export class ReelSpin extends ReelInit {


    constructor() {
        super();



    }


    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();

    }

    private generateMovingSteps(reelSymbolsMatrix: number[][]): { movingSteps: number[][]; anticipationPositions: Array<{ reelNum: number; posNum: number }> } {

        const REEL_NUMBERS = 5;
        const SYMBOLS_PER_REEL = reelSymbolsMatrix[0]?.length || 0;

        const movingSteps: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(0)
        );

        const blankSymbols: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(-1)
        );

        let startVal = 5;
        let blankSymbolCount = 0;
        let reelStepOffset = 0;


        //checking for only 5x5 grid
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            let reelHasBlank = false;

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                if (reelSymbolsMatrix[reelNum][posNum] === BLANK_SYM_ID) {
                    reelHasBlank = true;

                    const steps = startVal + (isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal ? 0 : reelStepOffset);
                    blankSymbolCount++;
                    blankSymbols[reelNum][posNum] = blankSymbolCount;
                    movingSteps[reelNum][posNum] = steps;
                } else {
                    movingSteps[reelNum][posNum] = 0;
                }
            }

            // Only increment for reels that have at least one blank
            if (reelHasBlank && !(isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal)) {
                reelStepOffset += 2;
            }
        }

        // till this point moving setps has been counted in array movingSteps


        // now we will see if additional moving is required for ancipation
        // for this check which are the last 3 cells to spin; for that use the array lastBlankSymbols


        //after the reelspin presentation the total count of coins
        let currentCoinCount = 0;
        for (const reel of reelSymbolsMatrix) {
            for (const symbolId of reel) {
                if (symbolId !== BLANK_SYM_ID) {
                    currentCoinCount += 1;
                }
            }
        }

        const maxSymbolsPerGrid = REEL_NUMBERS * SYMBOLS_PER_REEL;
        const anticipationPositions: Array<{ reelNum: number; posNum: number }> = [];

        if (currentCoinCount >= (maxSymbolsPerGrid - 3)) {
            const lastBlankSymbols = Array.from({ length: REEL_NUMBERS }, () =>
                Array(SYMBOLS_PER_REEL).fill(0)
            );

            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                    if (blankSymbols[reelNum][posNum] !== -1 && (blankSymbolCount - blankSymbols[reelNum][posNum] < 3)) {
                        lastBlankSymbols[reelNum][posNum] = 1;
                    }
                }
            }

            let incrementValue = 10; // start from +10
            for (let i = 0; i < REEL_NUMBERS; i++) {
                for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                    if (lastBlankSymbols[i][j] === 1) {
                        movingSteps[i][j] += incrementValue;
                        anticipationPositions.push({ reelNum: i, posNum: j });
                        incrementValue += 10; // next +10
                    }
                }
            }
        }

        console.log("movingSteps movingSteps", movingSteps);
        console.log("movingSteps blankSymbols", blankSymbols);

        return { movingSteps, anticipationPositions };
    }



    private spinLeft: number = -1;

    private meterPrefix = "multi_respin";

    public async startReels(currentRespinIndex: number): Promise<void> {

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        if (this.spinLeft == -1) { // first time appear

            this.duplicateInitialReel(currentRespinIndex);

            // Backend feature ids: 'zeus' | 'hades' | 'poseidon'
            this.spinLeft = spinData.freeGameTrigger = 3;

            this.spinLeftMeter.visible = true;
            this.winCollectionMeter.visible = false;


            this.spinLeftMeter.state.setAnimation(0, "multi_respin_appear", false).listener = {
                complete: () => {
                    if (this.spinLeft == 4) {
                        this.spinLeftMeter.state.setAnimation(0, "extra_respin_4_appear", false);
                        this.meterPrefix = "extra_respin";
                        setTimeout(() => {
                            sound.play("extra_spin_awarded", { volume: 1 });
                        }, 300);
                        // sound.play("extra_spin_awarded");
                    }
                    this.spinLeftMeter.state.clearListeners();
                }
            };
            this.spinLeftMeter.state.timeScale = timeScale;

            // reset multiplierValues
            // this.multiplierValues = Array.from({ length: REEL_NUMBERS }, () =>
            //     Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
            // );

        }

        await new Promise(resolve => setTimeout(resolve, 1000));

        // if (spinData.respins[currentRespinIndex - 1].spinLeft != null) {
        //     const spinLeftValue = spinData.respins[currentRespinIndex - 1].spinLeft.value - 1;
        //     console.log("spinLeftValue", spinLeftValue);
        //     Manager.casinoChannelHandler.reportUpdateFeatureCounter(spinLeftValue);
        // }

        this.spinLeftMeter.state.setAnimation(0, `${this.meterPrefix}_${this.spinLeft}_out`, false)

        // .listener = {
        //     complete: () => {
        // this.spinLeftMeter.state.clearListeners();
        // sound.play("coin_appear_sound", { volume: 1 });
        // sound.play("jackpot_symbol_flip", { volume: 1 });
        // }
        // };
        this.spinLeftMeter.state.timeScale = timeScale;

        this.spinLeft = this.spinLeft - 1;
        Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.spinLeft);

        const reelSymbolsMatrix: number[][] = this.prevReelSymbols;

        this.stopAllSymbolAnticipation();

        const { movingSteps, anticipationPositions } = this.generateMovingSteps(reelSymbolsMatrix);

        for (const { reelNum, posNum } of anticipationPositions) {
            this.playSymbolAnticipation(reelNum, posNum);
        }

        console.log("inside startReels hold and spin", currentRespinIndex, reelSymbolsMatrix);


        this.prevReelSymbols = spinData.respins[currentRespinIndex].reelSymbols;



        sound.play(SoundConstants.REELS_SPIN, { loop: true, volume: 0.5 });
        const promises: Promise<void>[] = [];

        for (let i = 0; i < reelSymbolsMatrix.length; i++) {
            for (let j = 0; j < reelSymbolsMatrix[i].length; j++) {

                if (reelSymbolsMatrix[i][j] == BLANK_SYM_ID) {
                    const repeatCount = movingSteps[i][j];
                    const promise = this.moveSymbolRepeatedly(currentRespinIndex, this.allReelArray[i].symbols[j], repeatCount, i, j);
                    promises.push(promise);
                }

            }
        }
        await Promise.all(promises);
        sound.stop(SoundConstants.REELS_SPIN);
        sound.play(SoundConstants.REEL_STOP);
        this.activatedSymbolLayering();
        await this.callWinSeq(currentRespinIndex);
        //await this.awardMultipliersToCoin(currentRespinIndex);

        if (spinData.respins[currentRespinIndex].spinLeft != null) {
            const spinLeftBackend = spinData.respins[currentRespinIndex].spinLeft.value;

            if (spinData.respins[currentRespinIndex].spinLeft.isReduceSpins == false /*&& this.spinLeft < spinLeftBackend*/) {

                const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                this.spinLeftMeter.state.setAnimation(0, `${this.meterPrefix}_${this.spinLeft}_in`, false);
                this.spinLeftMeter.state.timeScale = timeScale;

                sound.play("spin_meter_refill", { volume: 0.8, speed: timeScale });

                Manager.casinoChannelHandler.reportUpdateFeatureCounter(spinLeftBackend);
            }

            this.spinLeft = spinLeftBackend;

        }

        // await this.allReelStop();
    }

    private activatedSymbolLayering() {
        const reelSymbolsMatrix: number[][] = this.prevReelSymbols;
        for (let i = 0; i < reelSymbolsMatrix.length; i++) {
            for (let j = 0; j < reelSymbolsMatrix[i].length; j++) {
                if ([13, 14, 15].indexOf(this.reelOverlaySymbols[i][j].symbolId) != -1) {
                    const reelOverlaySymbolView = this.reelOverlaySymbols[i][j].view;
                    this.reelOverlayContainer.addChild(reelOverlaySymbolView);
                }
            }
        }
    }

    private callWinSeq(currentRespinIndex: number): Promise<void> {
        return new Promise<void>(async (resolve) => {
            await DisplayComponent.get(WinSeqComponent).startWinSeqFeature(currentRespinIndex, resolve);
        });
    }

    private duplicateInitialReel(currentRespinIndex: number) {

        const initialCoinValues = spinData.respins[currentRespinIndex].initialCoinValues;
        const initialSymbols = spinData.respins[currentRespinIndex].reelSymbols;

        for (let i = 0; i < initialCoinValues.length; i++) {
            for (let j = 0; j < initialCoinValues[i].length; j++) {

                if (this.prevReelSymbols[i][j] == BLANK_SYM_ID && initialCoinValues[i][j] > 0) {

                    const finalMultVal = initialCoinValues[i][j];

                    // const finalSymbolId = 12; // gold coin's id
                    const finalSymbolId = initialSymbols[i][j];

                    const symbolObj = this.allReelArray[i].symbols[j];
                    const indexInView = 1 - symbolObj.IdxCellOffView;

                    symbolObj.cells[indexInView].symbolId = finalSymbolId;
                    symbolObj.cells[indexInView].coinVal = finalMultVal;

                    this.addReelSymbolsToContainer(i, j);

                }
            }

        }

    }


    private async moveSymbolRepeatedly(currentRespinIndex: number, symbolObj: SymbolObject, count: number, reelNum: number, posNum: number): Promise<void> {

        let finalSymbolId = spinData.respins[currentRespinIndex].reelSymbols[reelNum][posNum];
        let finalMultVal = spinData.respins[currentRespinIndex].coinValues[reelNum][posNum];

        let reelSymbols = spinData.respins[currentRespinIndex].reelSymbols;
        //const 
        let randSymIds = [23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 22, 22, 22]// 13, 14, 15];
        spinData.triggerFeatures.forEach((feature) => {
            switch (feature) {
                case "poseidon":
                    randSymIds.push(13);
                    break;
                case "hades":
                    randSymIds.push(14);
                    break;
                case "zeus":
                    randSymIds.push(15);
                    break;
            }
        });

        // turn on the alpha of top symbol ( above the mask )
        symbolObj.cells[symbolObj.IdxCellOffView].symbol.alpha = 1;

        for (let i = 0; i < count; i++) {

            // texture swap

            const indexOffView = symbolObj.IdxCellOffView;
            const symbol = symbolObj.cells[indexOffView].symbol;
            const coinValText = symbolObj.cells[indexOffView].coinValText;


            if (i == count - 1) { // final move

                symbol.texture = getSymbol(finalSymbolId, true);

                if (finalSymbolId == 22) { // normal gold coin's id
                    coinValText.text = `${finalMultVal}x`;
                }
                if ([13, 14, 15, 16, 17, 18, 19, 20, 21, 24, 25, 26].indexOf(finalSymbolId) != -1) {
                    console.log(reelSymbols);
                    console.log(spinData.respins);
                }
            }
            else {
                const randId = randSymIds[Math.floor(Math.random() * randSymIds.length)];
                symbol.texture = getSymbol(randId, true);
                coinValText.text = "";
            }

            await this.moveSymbol(symbolObj);

            const indexInView = 1 - symbolObj.IdxCellOffView;

            symbolObj.cells[indexInView].symbolId = finalSymbolId;
            symbolObj.cells[indexInView].coinVal = finalMultVal;
            // if (i == count - 1) {
            //     console.log("IdxCellInView y", symbolObj.cells[indexInView].view.y)
            // }
        }

        if (finalSymbolId != BLANK_SYM_ID) {
            this.addReelSymbolsToContainer(reelNum, posNum);
            this.stopSymbolAnticipation(reelNum, posNum);
            // sound.play('coin_appear_sound', { volume: 1 });
        }
        else {
            // sound.play('reel_stop');
        }

        // change the alpha of top symbol ( above the mask to 0)
        symbolObj.cells[symbolObj.IdxCellOffView].symbol.alpha = 0;

    }



    private async moveSymbol(symbolObj: SymbolObject): Promise<void> {
        return new Promise<void>((resolve) => {
            let currentVal = 0;
            const targetVal = 1;

            const tween = new Tween({ x: currentVal }, reelTweenGroup)
                .to({ x: targetVal }, isSuperQuickBtnOnGlobal ? 100 : 200)
                .onUpdate((obj) => {
                    currentVal = obj.x;

                    for (let i = 0; i < symbolObj.cells.length; i++) {
                        const isVisible = i === symbolObj.IdxCellOffView;
                        symbolObj.cells[i].view.y = (isVisible ? -SYMBOL_HEIGHT : 0) + currentVal * SYMBOL_HEIGHT;
                    }
                })
                .onComplete(() => {
                    reelTweenGroup.remove(tween);

                    // Reset positions
                    for (let i = 0; i < symbolObj.cells.length; i++) {
                        symbolObj.cells[i].view.y = (i === symbolObj.IdxCellOffView ? 0 : -SYMBOL_HEIGHT);
                    }

                    // Flip view index
                    symbolObj.IdxCellOffView = 1 - symbolObj.IdxCellOffView;

                    resolve();
                })
                .start();
        });
    }

    // private multiplierValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
    //     Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
    // );

    protected async awardMultipliersToCoin(currentRespinIndex: number): Promise<void> {

        //const multiplierValues = spinData.respins[currentRespinIndex].multiplierValues;
        const multiplierValues = spinData.respins[currentRespinIndex].coinValues;

        if (multiplierValues == null || multiplierValues == undefined) {
            return Promise.resolve();
        }

        // let newMultFound = false;
        // const newMultiplierValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
        //     Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
        // );

        // for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
        //     for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

        //         const multiplierValue = spinData.respins[currentRespinIndex].multiplierValues[reelNum][posNum];

        //         if (multiplierValue > 0) {
        //             newMultiplierValues[reelNum][posNum] = multiplierValue;
        //             newMultFound = true;
        //         }
        //     }
        // }

        // // if (newMultFound) {
        // //     // Deep copy (not reference assignment)
        // //     this.multiplierValues = spinData.respins[currentRespinIndex].multiplierValues.map(row => [...row]);
        // // }

        // // console.log("astroid newMultiplierValues ", newMultiplierValues);
        // // console.log("astroid this.multiplierValues ", this.multiplierValues);

        // if (!newMultFound) {
        //     return Promise.resolve();
        // }

        return new Promise(async (resolve) => {

            const animationPromises: Promise<void>[] = [];

            this.totalWinVal = 0;

            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

                    // console.log("inside awardMultipliersToCoin", reelNum, posNum, this.reelOverlaySymbols[reelNum][posNum]);

                    const multVal = multiplierValues[reelNum][posNum];

                    if (multVal > 0) {

                        const animationPromise = this.addMultToCoinInContainer(reelNum, posNum, multVal);
                        animationPromises.push(animationPromise);

                        await new Promise(resolve => setTimeout(resolve, 500));

                    }
                }
            }



            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);
                resolve();
            }
            else {
                resolve();
            }

        })
    }





}
